import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-roubo-furto',
  templateUrl: './consulta-roubo-furto.component.html',
  styleUrls: ['./consulta-roubo-furto.component.scss']
})
export class ConsultaRouboFurtoComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {
    this.setStatus();
  }

  ngOnChanges() {
    this.setStatus();
  }

  setStatus() {
    let ocorrencia = this.consulta.ocorrencia ?? '';
    if(this.consulta && this.consulta.lista) {
      if(this.consulta.lista.length > 0 || ocorrencia === "VEICULO POSSUI ROUBO/FURTO ATIVO") {
        this.statusMsg = "CONSTAM  OCORRÊNCIAS DE ROUBO E FURTO";
        this.status = "danger";
      } else {
        this.statusMsg = "NÃO CONSTA OCORRÊNCIA";
        this.status = "success";
      }

    }

  }

}
